var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.619 2.227H2.087C1.127 2.227 0 3.332 0 4.313v15.65c0 .98 1.127 2.086 2.087 2.086h26.082c.96 0 2.086-1.106 2.086-2.087v-7.855a6.24 6.24 0 01-3.13 1.512v.084c0 .688-.375 1.043-1.043 1.043H3.13c-.668 0-1.043-.355-1.043-1.043V12.66c0-.69.375-1.044 1.043-1.044h18.289a6.24 6.24 0 011.2-9.39z",
    fill: "#697386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.177 5.355H0v3.13h19.906a6.301 6.301 0 01.271-3.13z",
    fill: "#697386"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.715 14.606a7.277 7.277 0 01-5.151-2.139 7.312 7.312 0 010-10.328 7.277 7.277 0 0110.303 0 7.312 7.312 0 010 10.328 7.277 7.277 0 01-5.152 2.14zM23.822 4.277H23L20.99 5.3v1.043l1.593-.834v4.82h1.25V4.277h-.011zm2.394.835c.593 0 1.01.334 1.01.814 0 .522-.49.887-1.197.887h-.313v.886h.375c.75 0 1.26.376 1.26.919 0 .521-.5.876-1.208.876-.52 0-1.04-.167-1.582-.49v1.043c.583.25 1.166.386 1.738.386 1.364 0 2.3-.7 2.3-1.711 0-.71-.437-1.283-1.165-1.513.624-.209 1.03-.761 1.03-1.387 0-.981-.864-1.649-2.113-1.649a4.155 4.155 0 00-1.634.355V5.55c.5-.281 1.01-.438 1.499-.438zm4.496 2.274c.76 0 1.29.45 1.29 1.033 0 .616-.53 1.044-1.29 1.044-.458 0-.937-.146-1.426-.449v1.075c.51.23 1.03.344 1.54.344.271 0 .521-.042.76-.104.542-.887.854-1.91.854-3.005l-.02-.438a2.39 2.39 0 00-1.281-.334c-.188 0-.385.01-.593.042V5.237h1.498a5.872 5.872 0 00-.478-.96h-2.103v3.287a5.154 5.154 0 011.25-.178z",
    fill: "#697386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/Cvc.8fe309f9a8836c2f3bb5ff9ad4d36cc7.svg";
export { ForwardRef as ReactComponent };